import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

export default function SuccessModal({ data, setData, handleClose }) {

  const onClose = () => {
    setData({ open: false });
    handleClose();
  };

  return (
    <Dialog open={data?.open}>
      <DialogTitle>Success</DialogTitle>
      <DialogContent>
        <Typography>{data?.title}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
